import React, { useContext } from 'react';
import env from '../utils/env.config';

import UsersTable from './users-table';
import SerialsTable from './serials-table';
import UsersSerialsContext from '../contexts/users-serials-context';
import Header from './header';

export default function Users() {
  const { users, serials } = useContext(UsersSerialsContext);

  return (
    <>
      <Header
        links={[
          { to: '/register-product', name: 'Register Product' },
          { to: `${env.SERVER_URL}/hauser.php`, name: 'DamaPlant WAC' },
          { to: '/logout', name: 'Logout' },
        ]}
      />
      <UsersTable data={users} />
      <SerialsTable data={serials} />
    </>
  );
}
